import {
	PRODUCT_TYPE_ALL,
	PRODUCT_TYPE_EVO,
	PRODUCT_TYPE_NOVA
} from '../../dashboard/product-filter';

export const getMessageLogProductType = log => {
	const storedProduct = parseInt(log && log.Product);
	if (storedProduct === PRODUCT_TYPE_EVO || storedProduct === PRODUCT_TYPE_NOVA) {
		return storedProduct;
	}

	const serialNumber = log && log.SerialNumber !== undefined && log.SerialNumber !== null
		? String(log.SerialNumber).trim().toUpperCase()
		: '';

	if (!serialNumber) {
		return PRODUCT_TYPE_ALL;
	}

	return serialNumber.indexOf('RJ') === 0 ? PRODUCT_TYPE_NOVA : PRODUCT_TYPE_EVO;
};

export const getMessageLogProductLabel = log => {
	const productType = getMessageLogProductType(log);

	if (productType === PRODUCT_TYPE_EVO) {
		return 'EVO';
	}

	if (productType === PRODUCT_TYPE_NOVA) {
		return 'Nova';
	}

	return 'Unknown';
};

export const filterMessageLogsByProduct = (logs, productType) => {
	const selectedProductType = parseInt(productType);
	const logList = logs || [];

	if (selectedProductType === PRODUCT_TYPE_ALL) {
		return logList;
	}

	return logList.filter(log => getMessageLogProductType(log) === selectedProductType);
};
